import { useEffect, useState } from 'react';
import { Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import { MdMoney, MdReceiptLong } from 'react-icons/md';
import Card from 'components/card/Card';
import Transaction from 'components/dataDisplay/Transaction';

type Compra = {
  id: number;
  TipoCuenta?: string | null;
  Total?: number | null;
  createdAt?: string | null;
  Provedor?: {
    RazonSocial?: string | null;
  } | null;
};

export default function YourCard(props: { [x: string]: any }) {
  const { ...rest } = props;
  const [movimientos, setMovimientos] = useState<Compra[]>([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const iconColor = useColorModeValue('brand.500', 'white');

  useEffect(() => {
    const fetchMovimientos = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_URL_SERVER + '/compras', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const result = await response.json();
        setMovimientos(Array.isArray(result) ? result.slice(0, 6) : []);
      } catch (error) {
        setMovimientos([]);
      }
    };

    fetchMovimientos();
    const timer = setInterval(fetchMovimientos, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Card {...rest}>
      <Flex align="center" justify="space-between" mb="24px">
        <Flex direction="column">
          <Text fontSize="xl" color={textColor} fontWeight="700">
            Ultimos Movimientos
          </Text>
          <Text fontSize="sm" color="secondaryGray.600" fontWeight="500">
            Compras y gastos recientes de la campaña
          </Text>
        </Flex>
        <Icon as={MdReceiptLong} color={iconColor} w="24px" h="24px" />
      </Flex>

      {movimientos.length === 0 ? (
        <Text color="secondaryGray.600" fontSize="sm" fontWeight="500">
          No hay compras registradas para esta sesión.
        </Text>
      ) : (
        movimientos.map((movimiento, index) => (
          <Transaction
            key={movimiento.id}
            mb={index === movimientos.length - 1 ? '0px' : '22px'}
            name={movimiento.Provedor?.RazonSocial || `Compra #${movimiento.id}`}
            date={movimiento.createdAt ? new Date(movimiento.createdAt).toLocaleDateString('es-MX') : 'Sin fecha'}
            sum={`$${Number(movimiento.Total || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
            concepto={movimiento.TipoCuenta || 'Gasto registrado'}
            icon={<Icon as={MdMoney} color={iconColor} w="20px" h="18px" />}
          />
        ))
      )}
    </Card>
  );
}
